
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`How to create space`}</h1>
    <h2>{`Set Typography`}</h2>
    <p>{`Typography ( at least titles, body text and line-height ) should be determined before we start to setup space.`}</p>
    <h2>{`Set a Memorable Base Number `}<br />{` Scale Options Nonlinearly`}</h2>
    <p><strong parentName="p">{`Predictable system`}</strong>{` that simplifies decision-making `}<strong parentName="p">{`has the minimum required number of values`}</strong>{`. Typically up to 4-5 values seem to provide enough variance - but you can add more intervals if you really feel the need during explorations.`}</p>
    <p><strong parentName="p">{`Memorable base number ground all other spatial values`}</strong>{`. Often used is used is e.g. 16. It’s a good default font size and it’s also a factor of all screen resolutions (320, 768, 1024).`}</p>
    <p><strong parentName="p">{`To prevent slip into random steps`}</strong>{` (12, 14, 16, 18, 22, 24, 28, 30, 32, …) `}<strong parentName="p">{`or linear scale`}</strong>{` (4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, …), `}<strong parentName="p">{`use nonlinear`}</strong>{` - options include the `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Golden_ratio"
      }}>{`golden ratio`}</a>{`, `}<a parentName="p" {...{
        "href": "https://zurb.com/word/modular-scale"
      }}>{`modular scale`}</a>{`, or the similar `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Geometric_progressio"
      }}>{`geometric progression`}</a>{`, that could double each step.`}</p>
    <p>{`Starting from the base, we’ll go in both directions to stops smaller (16, 8, 4, 2) and larger (16, 32, 64, …) on the scale.`}</p>
    <h2>{`Apply Spacing Values In A Predictable Way`}<br />{`Keep Rule Of 3Cs (Containers, Content & Components )`}</h2>
    <h3>{`1st C: Rule for Containers`}</h3>
    <p>{`Containers are frames in UI which hold content in them. Typically these are pages, cards, modals, panes, etc. Since containers are at the highest level in hierarchy, they should have the highest spacing value.`}</p>
    <p><strong parentName="p">{`Content indents on all four sides using padding`}</strong>{` - like the matte of the framed photo on a wall (used e.g. in cards or alerts).`}</p>
    <p>{`Since space inside containers is created by margin-bottom of content and components, there is another rule - `}<strong parentName="p">{`remove margin-bottom of the last stacked item`}</strong>{` in every container.`}</p>
    <p><strong parentName="p">{`Tip:`}</strong>{` Never include border in any spacing calculations ( a good explanation is provided in `}<a parentName="p" {...{
        "href": "https://builttoadapt.io/8-point-grid-borders-and-layouts-e91eb97f5091"
      }}>{`Elliot Dahl’s 8-point grid: Borders and Layouts`}</a>{` post.`}</p>
    <h3>{`2st C: Rule for Contents`}</h3>
    <p>{`Content lives inside the container. It contains headers (h1, h2, h3, h4, h5, h6) and data in the form of paragraphs, lists, forms, tables, etc.`}</p>
    <p><strong parentName="p">{`All content is stacked vertically using margins`}</strong>{` ( mainly margin-bottom ).`}</p>
    <h3>{`3st C: Rule for Components`}</h3>
    <p>{`Components are basic building blocks which can be combined into larger, more complex elements. They can be inline or block.`}</p>
    <h4>{`Block components`}</h4>
    <p>{`Block components are fullwidth and `}<strong parentName="p">{`have margin-bottom as other stacked content`}</strong>{` ( alerts, list, etc. ).`}</p>
    <h4>{`Inline components`}</h4>
    <p>{`Inline components `}<strong parentName="p">{`are often placed next to each other horizontally`}</strong>{` ( they flow like text from the left or right, e.g. buttons, icons, badges ).`}</p>
    <p><strong parentName="p">{`Source:`}</strong></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://medium.com/eightshapes-llc/space-in-design-systems-188bcbae0d62"
        }}>{`Space in Design Systems`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://blog.prototypr.io/a-framework-for-creating-a-predictable-and-harmonious-spacing-system-8eee8aaf773c"
        }}>{`A framework for creating a predictable & harmonious spacing system for faster design-dev handoff`}</a></li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;